import React from "react";
import Header from "./Header";

interface Props {

}

const PublicHeader = (props: Props) => {
    return (
        <Header
            routes={[
                {
                    path: ["/accueil", "/"],
                    label: "Accueil",
                },
                {
                    path: "/prestation",
                    label: "Nos prestations",
                },
                {
                    path: "/animaux",
                    label: "Nos animaux",
                },
                {
                    path: "/a-propos",
                    label: "A propos",
                },
                {
                    path: "/contact",
                    label: "Contact",
                },
                {
                    path: "/actualites",
                    label: "Actualités",
                },
            ]}
        />
    )
}

export default PublicHeader
